// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ManageProduct.css */

/* ======================================================= */
/* 📱 MOBILE LAYOUT (Default styles for screens < 768px) */
/* ======================================================= */

/* --- Global & Container Styles --- */

.AddProduct {
    /* Base padding reduced for mobile */
    padding: 1px 10px; 
    background-color: #303030;
    min-height: 100vh;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.AddProduct h1 {
    /* Mobile: Centered, minimal side margin */
    color: white;
    font-size: 1.3rem;
    text-align: center;
    margin: 30px 10px;
    font-family: 'GlitchGoblin', sans-serif;
    font-weight: 600;
}

.product-page-container {
    /* Mobile: Takes up more width, reduced padding */
    width: 100%; /* Use full width */
    margin: 20px auto;
    background-color: #fff;
    border-radius: 8px; /* Slightly smaller radius for mobile */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); 
    overflow: auto;
}

h3 {
    color: #2c3e50;
    font-size: 1.8rem; /* Reduced font size */
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
}

/* --- NEW: Button Group Layout (Mobile Stacking) --- */
.button-group {
    /* Stack buttons vertically by default on mobile */
    display: flex;
    flex-direction: column; 
    gap: 15px; /* Spacing between stacked buttons */
    margin-bottom: 25px;
}

/* --- Primary Add Buttons (Scoped with .AddProduct) --- */
.AddProduct .add-button {
    background-color: #3498db;
    color: white;
    border: none;
    padding: 10px 20px; 
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    border-radius: 6px; 
    transition: background-color 0.3s ease, transform 0.2s ease;
    box-shadow: 0 3px 8px rgba(52, 152, 219, 0.2);
    width: 100%; 
    margin: 0; 
}

.AddProduct .add-button:hover {
    background-color: #2980b9; 
    transform: translateY(-1px); 
}

/* --- Table Styling --- */
.product-page-container table, 
.product-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 8px; 
    overflow: hidden; 
    overflow-x: auto;
    white-space: nowrap; 
}

th, td {
    padding: 10px; 
    text-align: left;
    border-bottom: 1px solid #666;
    font-size: 0.9rem;
}

th {
    background-color: #f8f9fa;
    color: #495057;
    font-weight: 600;
    text-transform: uppercase;
}

tbody tr:nth-child(odd) { background-color: #ffffff; color: #666; }
tbody tr:nth-child(even) { background-color: #fcfcfc; color: #666; }

/* 🌟 ADDED: PRODUCT ACTIONS CELL STYLING 🌟 */
.product-actions-cell {
    /* Ensures the action column is wide enough to hold all 3 buttons */
    min-width: 280px; 
    padding-right: 15px;
}

/* --- Table Action Buttons --- */
.AddProduct td button {
    /* Base style for all table buttons (Edit/Delete/Manage) */
    margin-right: 5px; 
    padding: 6px 10px; 
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.8rem;
    background-color: #f0f3f5;
    color: #34495e; /* Default table button text color */
    transition: background-color 0.3s ease;
    width: auto; 
}

.AddProduct td button:hover {
    background-color: #e2e6ea;
}

/* 1. EDIT BUTTON (1st button) - Primary Blue */
.AddProduct td button:first-child { 
    background-color: #3498db; 
    color: white;
    border-color: #3498db;
}

.AddProduct td button:first-child:hover {
    background-color: #2980b9;
    border-color: #2980b9;
}


/* 2. DELETE BUTTON (2nd button) - Red */
.AddProduct td button:nth-child(2) {
    background-color: #e74c3c;
    color: white;
    border-color: #e74c3c;
}

.AddProduct td button:nth-child(2):hover {
    background-color: #c0392b;
}

/* 3. MANAGE ITEMS BUTTON (3rd button) - Primary Green */
.AddProduct td button:nth-child(3) {
    background-color: #2ecc71; 
    color: white;
    border-color: #2ecc71;
}

.AddProduct td button:nth-child(3):hover {
    background-color: #27ae60;
    border-color: #27ae60;
}


/* --- Form & Modal Styling --- */

.form-group {
    margin-bottom: 20px;
}

/* FIXED: Ensure the delete button is aligned with text */
.item-note {
    font-size: 0.9em;
    color: #666;
    margin: 5px 0 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 20px; 
    border-radius: 8px; 
    position: relative;
    width: 80%; 
    max-width: none; 
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transform: scale(0.95);
    animation: modalFadeIn 0.3s forwards;
    max-height: 90vh; 
    overflow-y: auto;
}

@keyframes modalFadeIn {
    to {
        transform: scale(1);
        opacity: 1;
    }
}

/* --- Modal Submission Button (HIGHLY SCOPED) --- */
.AddProduct .modal-content form button[type="submit"] {
    /* Inherits default modal button styles, but overrides color */
    width: 100%;
    padding: 12px;
    background-color: #2ecc71; 
    font-weight: 700;
    font-size: 1rem;
    border-radius: 6px; 
    color: white; /* Ensure text color is white */
    border: none;
    margin-top: 15px;
    
}

.AddProduct .modal-content form button[type="submit"]:hover {
    background-color: #27ae60;
}

/* --- UNIQUE Delete Item Button (HIGHLY SCOPED) --- */
.AddProduct .modal-delete-item {
    /* Override general modal button styles */
    width: auto !important; 
    padding: 6px 12px !important;
    background-color: #e74c3c !important; 
    color: white !important;
    border: none !important;
    font-size: 0.9rem !important;
    margin-left: 15px !important; 
    box-shadow: none !important;
    transition: background-color 0.2s ease;
}

.AddProduct .modal-delete-item:hover {
    background-color: #c0392b !important;
    transform: none !important;
}


/* Input/Textarea base styles (Rest of form styling remains good) */
form label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #34495e;
    font-size: 0.95rem;
}

form input[type="text"],
form input[type="number"],
form textarea,
.selectedProduct { 
    width: 100%;
    padding: 10px;
    border: 1px solid #e0e6ed;
    border-radius: 6px;
    box-sizing: border-box;
    font-size: 0.95rem;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

form input:focus,
form textarea:focus,
.selectedProduct:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
}

.close-button {
    position: absolute;
    top: 15px;
    right: 15px;
    background: transparent;
    border: none;
    font-size: 2rem; 
    cursor: pointer;
    color: #95a5a6;
    transition: color 0.2s ease;
}

/* Custom dropdown arrow styling */
.selectedProduct {
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 16px 16px;
    padding-right: 30px;
    cursor: pointer;
}

/* --- NEW: Gallery Integration Styling --- */
.image-input-group {
    /* Layout for input field and the gallery button side-by-side */
    display: flex;
    gap: 10px;
    align-items: center;
}

.image-input-group input[type="text"] {
    flex-grow: 1; /* Makes the input field fill available space */
}

.gallery-button {
    /* Custom button styling for the gallery trigger */
    background-color: #4CAF50; /* A friendly green color */
    color: white;
    border: none;
    padding: 10px 15px; /* Matches form input height nicely */
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap; /* Prevents button text from wrapping */
    transition: background-color 0.2s;
    font-size: 0.95rem;
}

.gallery-button:hover {
    background-color: #45a049; /* Darker hover color */
}

.image-preview {
    /* Style for the image thumbnail preview */
    max-width: 150px; 
    max-height: 100px;
    object-fit: contain;
    display: block;
    margin-top: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

/* --- Gallery Modal Specific Styling (The Gallery.js component modal) --- */
.gallery-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7); /* Slightly darker background for focus */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000; /* Higher Z-index than the other modals */
}

.gallery-modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    position: relative;
    width: 90%;
    max-width: 1000px; /* Wider modal for image display */
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    max-height: 90vh;
    overflow-y: auto;
    animation: modalFadeIn 0.3s forwards;
}


/* ======================================================= */
/* 💻 DESKTOP LAYOUT (Styles for screens >= 768px) */
/* ======================================================= */

@media screen and (min-width: 768px) {
    
    /* --- Container & Title Restore --- */
    .AddProduct {
        padding: 1px 20px;
    }

    .AddProduct h1 {
        font-size: 1.5rem;
        margin: 40px 250px; 
    }
    
    .product-page-container {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08); 
    }

    h3 {
        font-size: 2.2rem;
        margin-bottom: 25px;
    }

    /* --- Button Group Layout (Horizontal Alignment) --- */
    .button-group {
        display: flex;
        flex-direction: row;
        justify-content: center; 
        gap: 30px; 
        margin-bottom: 40px;
    }

    .button-group .add-button {
        width: auto;
        padding: 12px 24px;
        font-size: 1rem;
        margin: 0;
    }
    
    /* --- Table Restore --- */
    .product-page-container table, 
    .product-table {
        border-radius: 12px;
        display: table; 
        overflow-x: hidden;
        white-space: normal;
    }

    th, td {
        padding: 15px; 
        font-size: 1rem;
    }

    td button {
        margin-right: 10px;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 1rem;
    }
    
    /* 🌟 DESKTOP PRODUCT ACTIONS CELL (Override mobile width) 🌟 */
    .product-actions-cell {
        width: 20%;
        min-width: 250px;
    }

    /* --- Form & Modal Restore --- */
    .modal-content {
        padding: 40px;
        max-width: 500px;
        /* CHANGE THESE TWO LINES */
        max-height: 90vh; 
        overflow-y: auto; 
    }
    
    .gallery-modal-content {
        padding: 40px;
        max-width: 1000px;
        max-height: 90vh;
    }

    form input[type="text"],
    form input[type="number"],
    form textarea,
    .selectedProduct {
        padding: 12px;
        font-size: 1rem;
    }
    
    form button[type="submit"] {
        padding: 15px;
        font-size: 1.1rem;
    }
    
    .close-button {
        font-size: 2.5rem;
    }
    
    .gallery-button {
        padding: 12px 18px;
        font-size: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/ManageProduct.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,4DAA4D;AAC5D,0DAA0D;AAC1D,4DAA4D;;AAE5D,sCAAsC;;AAEtC;IACI,oCAAoC;IACpC,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,4DAA4D;AAChE;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,WAAW,EAAE,mBAAmB;IAChC,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB,EAAE,uCAAuC;IAC3D,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB,EAAE,sBAAsB;IACzC,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,uDAAuD;AACvD;IACI,kDAAkD;IAClD,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,oCAAoC;IAC/C,mBAAmB;AACvB;;AAEA,0DAA0D;AAC1D;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,2DAA2D;IAC3D,6CAA6C;IAC7C,WAAW;IACX,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;;IAEI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,0BAA0B,yBAAyB,EAAE,WAAW,EAAE;AAClE,2BAA2B,yBAAyB,EAAE,WAAW,EAAE;;AAEnE,8CAA8C;AAC9C;IACI,mEAAmE;IACnE,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,0DAA0D;IAC1D,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc,EAAE,oCAAoC;IACpD,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,+CAA+C;AAC/C;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA,wCAAwC;AACxC;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wDAAwD;AACxD;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA,iCAAiC;;AAEjC;IACI,mBAAmB;AACvB;;AAEA,yDAAyD;AACzD;IACI,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,0CAA0C;IAC1C,sBAAsB;IACtB,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,oDAAoD;AACpD;IACI,8DAA8D;IAC9D,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY,EAAE,+BAA+B;IAC7C,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sDAAsD;AACtD;IACI,yCAAyC;IACzC,sBAAsB;IACtB,4BAA4B;IAC5B,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;;AAGA,mEAAmE;AACnE;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;;IAII,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;IAChB,yDAAkL;IAClL,4BAA4B;IAC5B,qCAAqC;IACrC,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;AACnB;;AAEA,6CAA6C;AAC7C;IACI,+DAA+D;IAC/D,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,+CAA+C;AACjE;;AAEA;IACI,kDAAkD;IAClD,yBAAyB,EAAE,2BAA2B;IACtD,YAAY;IACZ,YAAY;IACZ,kBAAkB,EAAE,qCAAqC;IACzD,kBAAkB;IAClB,eAAe;IACf,mBAAmB,EAAE,uCAAuC;IAC5D,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;AACtD;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,4EAA4E;AAC5E;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B,EAAE,yCAAyC;IACzE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,yCAAyC;AAC5D;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,iBAAiB,EAAE,kCAAkC;IACrD,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;AACxC;;;AAGA,4DAA4D;AAC5D,oDAAoD;AACpD,4DAA4D;;AAE5D;;IAEI,sCAAsC;IACtC;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA,uDAAuD;IACvD;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,SAAS;IACb;;IAEA,0BAA0B;IAC1B;;QAEI,mBAAmB;QACnB,cAAc;QACd,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;IACnB;;IAEA,+DAA+D;IAC/D;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA,iCAAiC;IACjC;QACI,aAAa;QACb,gBAAgB;QAChB,2BAA2B;QAC3B,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;;;;QAII,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":["/* ManageProduct.css */\n\n/* ======================================================= */\n/* 📱 MOBILE LAYOUT (Default styles for screens < 768px) */\n/* ======================================================= */\n\n/* --- Global & Container Styles --- */\n\n.AddProduct {\n    /* Base padding reduced for mobile */\n    padding: 1px 10px; \n    background-color: #303030;\n    min-height: 100vh;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.AddProduct h1 {\n    /* Mobile: Centered, minimal side margin */\n    color: white;\n    font-size: 1.3rem;\n    text-align: center;\n    margin: 30px 10px;\n    font-family: 'GlitchGoblin', sans-serif;\n    font-weight: 600;\n}\n\n.product-page-container {\n    /* Mobile: Takes up more width, reduced padding */\n    width: 100%; /* Use full width */\n    margin: 20px auto;\n    background-color: #fff;\n    border-radius: 8px; /* Slightly smaller radius for mobile */\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); \n    overflow: auto;\n}\n\nh3 {\n    color: #2c3e50;\n    font-size: 1.8rem; /* Reduced font size */\n    font-weight: 600;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n/* --- NEW: Button Group Layout (Mobile Stacking) --- */\n.button-group {\n    /* Stack buttons vertically by default on mobile */\n    display: flex;\n    flex-direction: column; \n    gap: 15px; /* Spacing between stacked buttons */\n    margin-bottom: 25px;\n}\n\n/* --- Primary Add Buttons (Scoped with .AddProduct) --- */\n.AddProduct .add-button {\n    background-color: #3498db;\n    color: white;\n    border: none;\n    padding: 10px 20px; \n    font-size: 0.95rem;\n    font-weight: 600;\n    cursor: pointer;\n    border-radius: 6px; \n    transition: background-color 0.3s ease, transform 0.2s ease;\n    box-shadow: 0 3px 8px rgba(52, 152, 219, 0.2);\n    width: 100%; \n    margin: 0; \n}\n\n.AddProduct .add-button:hover {\n    background-color: #2980b9; \n    transform: translateY(-1px); \n}\n\n/* --- Table Styling --- */\n.product-page-container table, \n.product-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    border-radius: 8px; \n    overflow: hidden; \n    overflow-x: auto;\n    white-space: nowrap; \n}\n\nth, td {\n    padding: 10px; \n    text-align: left;\n    border-bottom: 1px solid #666;\n    font-size: 0.9rem;\n}\n\nth {\n    background-color: #f8f9fa;\n    color: #495057;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\ntbody tr:nth-child(odd) { background-color: #ffffff; color: #666; }\ntbody tr:nth-child(even) { background-color: #fcfcfc; color: #666; }\n\n/* 🌟 ADDED: PRODUCT ACTIONS CELL STYLING 🌟 */\n.product-actions-cell {\n    /* Ensures the action column is wide enough to hold all 3 buttons */\n    min-width: 280px; \n    padding-right: 15px;\n}\n\n/* --- Table Action Buttons --- */\n.AddProduct td button {\n    /* Base style for all table buttons (Edit/Delete/Manage) */\n    margin-right: 5px; \n    padding: 6px 10px; \n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 0.8rem;\n    background-color: #f0f3f5;\n    color: #34495e; /* Default table button text color */\n    transition: background-color 0.3s ease;\n    width: auto; \n}\n\n.AddProduct td button:hover {\n    background-color: #e2e6ea;\n}\n\n/* 1. EDIT BUTTON (1st button) - Primary Blue */\n.AddProduct td button:first-child { \n    background-color: #3498db; \n    color: white;\n    border-color: #3498db;\n}\n\n.AddProduct td button:first-child:hover {\n    background-color: #2980b9;\n    border-color: #2980b9;\n}\n\n\n/* 2. DELETE BUTTON (2nd button) - Red */\n.AddProduct td button:nth-child(2) {\n    background-color: #e74c3c;\n    color: white;\n    border-color: #e74c3c;\n}\n\n.AddProduct td button:nth-child(2):hover {\n    background-color: #c0392b;\n}\n\n/* 3. MANAGE ITEMS BUTTON (3rd button) - Primary Green */\n.AddProduct td button:nth-child(3) {\n    background-color: #2ecc71; \n    color: white;\n    border-color: #2ecc71;\n}\n\n.AddProduct td button:nth-child(3):hover {\n    background-color: #27ae60;\n    border-color: #27ae60;\n}\n\n\n/* --- Form & Modal Styling --- */\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n/* FIXED: Ensure the delete button is aligned with text */\n.item-note {\n    font-size: 0.9em;\n    color: #666;\n    margin: 5px 0 15px 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    padding: 20px; \n    border-radius: 8px; \n    position: relative;\n    width: 80%; \n    max-width: none; \n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    transform: scale(0.95);\n    animation: modalFadeIn 0.3s forwards;\n    max-height: 90vh; \n    overflow-y: auto;\n}\n\n@keyframes modalFadeIn {\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n/* --- Modal Submission Button (HIGHLY SCOPED) --- */\n.AddProduct .modal-content form button[type=\"submit\"] {\n    /* Inherits default modal button styles, but overrides color */\n    width: 100%;\n    padding: 12px;\n    background-color: #2ecc71; \n    font-weight: 700;\n    font-size: 1rem;\n    border-radius: 6px; \n    color: white; /* Ensure text color is white */\n    border: none;\n    margin-top: 15px;\n    \n}\n\n.AddProduct .modal-content form button[type=\"submit\"]:hover {\n    background-color: #27ae60;\n}\n\n/* --- UNIQUE Delete Item Button (HIGHLY SCOPED) --- */\n.AddProduct .modal-delete-item {\n    /* Override general modal button styles */\n    width: auto !important; \n    padding: 6px 12px !important;\n    background-color: #e74c3c !important; \n    color: white !important;\n    border: none !important;\n    font-size: 0.9rem !important;\n    margin-left: 15px !important; \n    box-shadow: none !important;\n    transition: background-color 0.2s ease;\n}\n\n.AddProduct .modal-delete-item:hover {\n    background-color: #c0392b !important;\n    transform: none !important;\n}\n\n\n/* Input/Textarea base styles (Rest of form styling remains good) */\nform label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: #34495e;\n    font-size: 0.95rem;\n}\n\nform input[type=\"text\"],\nform input[type=\"number\"],\nform textarea,\n.selectedProduct { \n    width: 100%;\n    padding: 10px;\n    border: 1px solid #e0e6ed;\n    border-radius: 6px;\n    box-sizing: border-box;\n    font-size: 0.95rem;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\nform input:focus,\nform textarea:focus,\n.selectedProduct:focus {\n    outline: none;\n    border-color: #3498db;\n    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);\n}\n\n.close-button {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: transparent;\n    border: none;\n    font-size: 2rem; \n    cursor: pointer;\n    color: #95a5a6;\n    transition: color 0.2s ease;\n}\n\n/* Custom dropdown arrow styling */\n.selectedProduct {\n    appearance: none;\n    background-image: url('data:image/svg+xml;utf8,<svg fill=\"%23333\" height=\"20\" viewBox=\"0 0 24 24\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>');\n    background-repeat: no-repeat;\n    background-position: right 8px center;\n    background-size: 16px 16px;\n    padding-right: 30px;\n    cursor: pointer;\n}\n\n/* --- NEW: Gallery Integration Styling --- */\n.image-input-group {\n    /* Layout for input field and the gallery button side-by-side */\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.image-input-group input[type=\"text\"] {\n    flex-grow: 1; /* Makes the input field fill available space */\n}\n\n.gallery-button {\n    /* Custom button styling for the gallery trigger */\n    background-color: #4CAF50; /* A friendly green color */\n    color: white;\n    border: none;\n    padding: 10px 15px; /* Matches form input height nicely */\n    border-radius: 6px;\n    cursor: pointer;\n    white-space: nowrap; /* Prevents button text from wrapping */\n    transition: background-color 0.2s;\n    font-size: 0.95rem;\n}\n\n.gallery-button:hover {\n    background-color: #45a049; /* Darker hover color */\n}\n\n.image-preview {\n    /* Style for the image thumbnail preview */\n    max-width: 150px; \n    max-height: 100px;\n    object-fit: contain;\n    display: block;\n    margin-top: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n}\n\n/* --- Gallery Modal Specific Styling (The Gallery.js component modal) --- */\n.gallery-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7); /* Slightly darker background for focus */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000; /* Higher Z-index than the other modals */\n}\n\n.gallery-modal-content {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    position: relative;\n    width: 90%;\n    max-width: 1000px; /* Wider modal for image display */\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n    max-height: 90vh;\n    overflow-y: auto;\n    animation: modalFadeIn 0.3s forwards;\n}\n\n\n/* ======================================================= */\n/* 💻 DESKTOP LAYOUT (Styles for screens >= 768px) */\n/* ======================================================= */\n\n@media screen and (min-width: 768px) {\n    \n    /* --- Container & Title Restore --- */\n    .AddProduct {\n        padding: 1px 20px;\n    }\n\n    .AddProduct h1 {\n        font-size: 1.5rem;\n        margin: 40px 250px; \n    }\n    \n    .product-page-container {\n        border-radius: 12px;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08); \n    }\n\n    h3 {\n        font-size: 2.2rem;\n        margin-bottom: 25px;\n    }\n\n    /* --- Button Group Layout (Horizontal Alignment) --- */\n    .button-group {\n        display: flex;\n        flex-direction: row;\n        justify-content: center; \n        gap: 30px; \n        margin-bottom: 40px;\n    }\n\n    .button-group .add-button {\n        width: auto;\n        padding: 12px 24px;\n        font-size: 1rem;\n        margin: 0;\n    }\n    \n    /* --- Table Restore --- */\n    .product-page-container table, \n    .product-table {\n        border-radius: 12px;\n        display: table; \n        overflow-x: hidden;\n        white-space: normal;\n    }\n\n    th, td {\n        padding: 15px; \n        font-size: 1rem;\n    }\n\n    td button {\n        margin-right: 10px;\n        padding: 8px 16px;\n        border-radius: 6px;\n        font-size: 1rem;\n    }\n    \n    /* 🌟 DESKTOP PRODUCT ACTIONS CELL (Override mobile width) 🌟 */\n    .product-actions-cell {\n        width: 20%;\n        min-width: 250px;\n    }\n\n    /* --- Form & Modal Restore --- */\n    .modal-content {\n        padding: 40px;\n        max-width: 500px;\n        /* CHANGE THESE TWO LINES */\n        max-height: 90vh; \n        overflow-y: auto; \n    }\n    \n    .gallery-modal-content {\n        padding: 40px;\n        max-width: 1000px;\n        max-height: 90vh;\n    }\n\n    form input[type=\"text\"],\n    form input[type=\"number\"],\n    form textarea,\n    .selectedProduct {\n        padding: 12px;\n        font-size: 1rem;\n    }\n    \n    form button[type=\"submit\"] {\n        padding: 15px;\n        font-size: 1.1rem;\n    }\n    \n    .close-button {\n        font-size: 2.5rem;\n    }\n    \n    .gallery-button {\n        padding: 12px 18px;\n        font-size: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
